import { render, staticRenderFns } from "./settings_routing.vue?vue&type=template&id=0a4b27fe&scoped=true&"
import script from "./settings_routing.vue?vue&type=script&lang=js&"
export * from "./settings_routing.vue?vue&type=script&lang=js&"
import style0 from "./settings_routing.vue?vue&type=style&index=0&id=0a4b27fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4b27fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VApp,VBtn,VCol,VContainer,VRow,VSubheader})
